import GallerySimple from '../blocks/gallery-simple';
import Gallery from '../blocks/gallery';
import GalleryVideo from '../blocks/gallery-video';
import GoogleMap from '../utils/map';


const templateServices = {
  init() {
    new GallerySimple('.gallery-simple');
    new Gallery('.gallery');
    new GalleryVideo('.gallery-video');
    templateServices.renderMap2();
  },

  renderMap2() {
    const mapEl = $("#map-wrap2");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);
  },
}
export default templateServices;
